import React from "react"
import styled from "styled-components"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { renderRichText } from "gatsby-source-contentful/rich-text"

// Utils
import { richTextOptions } from "@utils/knowledge-center"

const CalloutContainer = styled.div`
  margin-top: 48px;
  border-left: ${props => `4px solid ${props.categoryColor}`};

  .callout-text p {
    color: ${props => props.categoryColor};
    padding: 12px 16px;
    font-size: 20px;
    line-height: 32px;
  }
`

const ArticleCallout = props => {
  const CategoryColor = () => {
    if (props.category === "finances") {
      return "#077577"
    }
    if (props.category === "mortgages") {
      return "#007ab4"
    }
    if (props.category === "homeownership") {
      return "#BD432B"
    }
  }
  return (
    <CalloutContainer
      className="article-callout article-component"
      categoryColor={CategoryColor()}
    >
      <div className="callout-text">
        {renderRichText(props.fields.callout, richTextOptions(props))}
      </div>
    </CalloutContainer>
  )
}

export default ArticleCallout
